import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import api from '@/lib/api';
import { PageHeader } from '@/components/PageHeader';
import { Bell, Check, MessageSquare, Megaphone, AlertTriangle } from 'lucide-react';

const ICON = { message: MessageSquare, broadcast: Megaphone, alert: AlertTriangle };

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get('/notifications'); setItems(data); };
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post('/notifications/read-all'); load(); };
  const read = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div data-testid="notifications-inbox">
      <PageHeader kicker="Bandeja" title="Notificaciones"
        actions={<button data-testid="read-all-btn" onClick={readAll} className="h-10 px-4 rounded-xl text-sm font-medium border flex items-center gap-2"><Check size={16} /> Marcar todo leído</button>} />
      <div className="space-y-3 max-w-2xl">
        <AnimatePresence>
          {items.map((n, i) => { const Icon = ICON[n.type] || Bell; return (
            <motion.div key={n.id} initial={{ opacity: 0, y: -30, rotate: -2 }} animate={{ opacity: 1, y: 0, rotate: 0 }} transition={{ type: 'spring', stiffness: 220, damping: 18, delay: i * 0.03 }}
              onClick={() => !n.read && read(n.id)} data-testid={`notif-${n.id}`}
              className={`pp-glass p-4 flex items-start gap-3 cursor-pointer ${!n.read ? 'pp-glow-mint' : 'opacity-70'}`}>
              <span className="w-9 h-9 rounded-xl grid place-items-center shrink-0 overflow-hidden bg-white" style={{ display: n.from_name === 'PlannerPRO' ? 'block' : 'none' }}>
                <img src="/brand/logo-principal.jpg" alt="PlannerPRO" className="w-full h-full object-cover" />
              </span>
              <span className="w-9 h-9 rounded-xl grid place-items-center shrink-0" style={{ background: n.type === 'broadcast' ? 'rgba(201,168,76,0.15)' : 'rgba(62,180,137,0.15)', display: n.from_name === 'PlannerPRO' ? 'none' : 'grid' }}><Icon size={16} className={n.type === 'broadcast' ? 'pp-gold' : 'pp-mint'} /></span>
              <div className="flex-1">
                <div className="font-medium text-sm flex items-center gap-2">{n.title}{!n.read && <span className="w-2 h-2 rounded-full" style={{ background: '#3EB489' }} />}</div>
                {n.body && <div className="text-sm text-muted-foreground mt-0.5">{n.body}</div>}
                <div className="text-[11px] text-muted-foreground mt-1">{n.from_name} · {new Date(n.created_at).toLocaleString('es')}</div>
              </div>
            </motion.div>
          ); })}
        </AnimatePresence>
        {items.length === 0 && <div className="pp-glass p-10 text-center text-muted-foreground"><Bell className="mx-auto mb-2" size={28} /> Todo al día.</div>}
      </div>
    </div>
  );
}
